<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="取证名称" prop="name">
                <Input type="text" v-model="searchForm.name" placeholder="请输入存证订单的标题，对于之前dci存证就是作品名称，司法存证就是存证名称" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="开始时间" prop="orderAuditStatus">
                <DatePicker
                  type="daterange"
                  v-model="selectDate"
                  format="yyyy-MM-dd"
                  clearable
                  @on-change="selectDateRange"
                  placeholder="选择起始时间"
                  style="width: 300px"
                ></DatePicker>
              </Form-item>
              <Form-item label="来源" prop="copyrightType">
                <Select v-model="searchForm.activityId" placeholder="请选择" clearable style="width: 200px">
                  <Option value="">全部</Option>
                  <Option v-for="(item, i) in activities" :key="i" :value="item.id">
                    {{item.name}}</Option>
                </Select>
                <!-- <Input type="text" v-model="searchForm.copyrightType" placeholder="请输入所属类型" clearable style="width: 200px"/> -->
              </Form-item>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="conditionExport" type="primary" icon="ios-search" v-hasRole="'ROLE_ADMIN'">根据查询条件导出</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <!--<Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>-->
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="取证主表" prop="evidenceOrder" >
          <Input v-model="form.evidenceOrder" style="width:100%"/>
        </FormItem>
        <FormItem label="取证主表扩展表" prop="evidenceOrderExtends" >
          <Input v-model="form.evidenceOrderExtends" style="width:100%"/>
        </FormItem>
        <FormItem label="支付方式" prop="payWay" >
          <Input v-model="form.payWay" style="width:100%"/>
        </FormItem>
        <FormItem label="id" prop="id" >
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <FormItem label="用户id" prop="registerId" >
          <Input v-model="form.registerId" style="width:100%"/>
        </FormItem>
        <FormItem label="取证网址" prop="url" >
          <Input v-model="form.url" style="width:100%"/>
        </FormItem>
        <FormItem label="域名" prop="domain" >
          <Input v-model="form.domain" style="width:100%"/>
        </FormItem>
        <FormItem label="取证说明" prop="content" >
          <Input v-model="form.content" style="width:100%"/>
        </FormItem>
        <FormItem label="申请渠道" prop="source" >
          <Input v-model="form.source" style="width:100%"/>
        </FormItem>
        <FormItem label="取证开始时间" prop="beginTime" >
            <DatePicker type="date" v-model="form.beginTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="取证结束时间" prop="endTime" >
            <DatePicker type="date" v-model="form.endTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="网页截图URL" prop="screenshotUrl" >
          <Input v-model="form.screenshotUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="证据包URL" prop="packageUrl" >
          <Input v-model="form.packageUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="创建者" prop="createBy" >
          <Input v-model="form.createBy" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createDate" >
            <DatePicker type="date" v-model="form.createDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="更新者" prop="updateBy" >
          <Input v-model="form.updateBy" style="width:100%"/>
        </FormItem>
        <FormItem label="更新时间" prop="updateDate" >
            <DatePicker type="date" v-model="form.updateDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="删除标记" prop="delFlag" >
          <Input v-model="form.delFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="取证名称" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="orderSeqNo" >
          <Input v-model="form.orderSeqNo" style="width:100%"/>
        </FormItem>
        <FormItem label="证据包长度" prop="pacageSize" >
          <Input v-model="form.pacageSize" style="width:100%"/>
        </FormItem>
        <FormItem label="package md5" prop="packageMd5" >
          <Input v-model="form.packageMd5" style="width:100%"/>
        </FormItem>
        <FormItem label="package sha256" prop="packageSha256" >
          <Input v-model="form.packageSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="截屏sha256" prop="screenshotSha256" >
          <Input v-model="form.screenshotSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="dns服务器ip" prop="dnsServerIp" >
          <Input v-model="form.dnsServerIp" style="width:100%"/>
        </FormItem>
        <FormItem label="取证服务器外网IP" prop="serverIp" >
          <Input v-model="form.serverIp" style="width:100%"/>
        </FormItem>
        <FormItem label="取证网页原码sha256" prop="sourceFileSha256" >
          <Input v-model="form.sourceFileSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程日志sha256" prop="logFileSha256" >
          <Input v-model="form.logFileSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="取证固定过程日志" prop="logContent" >
          <Input v-model="form.logContent" style="width:100%"/>
        </FormItem>
        <FormItem label="DNS返回网址对应IP" prop="dnsDomainIp" >
          <Input v-model="form.dnsDomainIp" style="width:100%"/>
        </FormItem>
        <FormItem label="网页原码文件" prop="sourceFileName" >
          <Input v-model="form.sourceFileName" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程文件名称" prop="processRecordFileName" >
          <Input v-model="form.processRecordFileName" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程文件hash" prop="processRecordFileSha256" >
          <Input v-model="form.processRecordFileSha256" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
    <Drawer width="640" v-model="infoDrawerVisible" title="网页取证详情">
      <!--<div slot="header">
        <Row>
          <Col>
            <span v-if="auditOrEdit == 'audit'">存证审核</span>
            <span v-if="auditOrEdit == 'edit'">存证详情</span>
          </Col>
        </Row>
        <Row type="flex" v-if="auditOrEdit == 'audit'" justify="space-around">
          <Button type="error" :loading="submitLoading" @click="auditOrderSubmit('filing_reject_frozen')">审核拒绝(不可)编辑</Button>
          <Button type="warn" :loading="submitLoading" @click="auditOrderSubmit('filing_reject_modify')">审核拒绝(可)编辑</Button>
          <Button type="primary" :loading="submitLoading" @click="auditOrderSubmit('filing_identify')">审核通过</Button>
        </Row>
      </div>-->
      <Form ref="infoForm" :model="infoForm" :label-width="100" :rules="formValidate" >
        <FormItem label="取证网址" prop="url" >
          <Input v-model="infoForm.url" style="width:100%"/>
        </FormItem>
        <FormItem label="取证名称" prop="name" >
          <Input v-model="infoForm.name" style="width:100%"/>
        </FormItem>
        <FormItem label="域名" prop="domain" >
          <Input v-model="infoForm.domain" style="width:100%"/>
        </FormItem>
        <FormItem label="状态" prop="infoForm.evidenceOrder" >
          <Input v-model="infoForm.evidenceOrder.status" style="width:100%"/>
          <!--<Select v-model="infoForm.evidenceOrder.status">
            <Option value="prepare">未开始</Option>
            <Option value="saving-evidence">取证中</Option>
            <Option value="evidence-saved">完成</Option>
            <Option value="failed">失败</Option>
            <Option value="cert-sign-issue">证书已生成</Option>
          </Select>-->
        </FormItem>
        <FormItem label="用户" prop="register" >
          <Input v-model="infoForm.register.name" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型" prop="register" >
          <Input v-model="infoForm.register.accountType" style="width:100%"/>
        </FormItem>
        <FormItem label="取证开始时间" prop="beginTime" >
          <DatePicker type="date" v-model="infoForm.beginTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="取证结束时间" prop="endTime" >
          <DatePicker type="date" v-model="infoForm.endTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="网页截图URL" prop="screenshotUrl" >
          <Input v-model="infoForm.screenshotUrl" style="width:100%"/>
          <img v-bind:src="infoForm.screenshotUrl" style="width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;  "/>
          <a :href="infoForm.screenshotUrl" target="_blank">点击查看/下载</a>
        </FormItem>
        <FormItem label="证据包URL" prop="packageUrl" >
          <Input v-model="infoForm.packageUrl" style="width:100%"/><a :href="infoForm.packageUrl" target="_blank">点击查看/下载</a>
        </FormItem>
        <FormItem label="存证证书编号" prop="evidenceArchiveCertNumber" >
          <Input v-model="infoForm.evidenceOrderExtends.evidenceArchiveCertNumber" style="width:100%"/>
        </FormItem>
        <FormItem label="校验码" prop="checkCode" >
          <Input v-model="infoForm.evidenceOrderExtends.checkCode" style="width:100%"/>
        </FormItem>
        <FormItem label="公示hash" prop="publicHash" >
          <Input v-model="infoForm.evidenceOrderExtends.publicHash" style="width:100%"/>
        </FormItem>
        <FormItem label="短连接" prop="shortUrl" >
          <Input v-model="infoForm.evidenceOrderExtends.shortUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="原始证书pdf地址" prop="certOriginalPdfUrl" >
          <Input v-model="infoForm.evidenceOrderExtends.certOriginalPdfUrl" style="width:100%"/><a :href="infoForm.evidenceOrderExtends.certOriginalPdfUrl" target="_blank">点击查看/下载</a>
        </FormItem>
        <FormItem label="签章证书pdf地址" prop="certSignaturePdfUrl" >
          <Input v-model="infoForm.evidenceOrderExtends.certSignaturePdfUrl" style="width:100%"/><a :href="infoForm.evidenceOrderExtends.certSignaturePdfUrl" target="_blank">点击查看/下载</a>
        </FormItem>

        <FormItem label="取证说明" prop="content" >
          <Input v-model="infoForm.content" style="width:100%"/>
        </FormItem>
        <FormItem label="申请渠道" prop="source" >
          <Input v-model="infoForm.source" style="width:100%"/>
        </FormItem>

        <FormItem label="创建者" prop="createBy" >
          <Input v-model="infoForm.createBy" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createDate" >
          <DatePicker type="date" v-model="infoForm.createDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="infoForm.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="订单编号" prop="orderSeqNo" >
          <Input v-model="infoForm.orderSeqNo" style="width:100%"/>
        </FormItem>
        <FormItem label="证据包长度" prop="pacageSize" >
          <Input v-model="infoForm.pacageSize" style="width:100%"/>
        </FormItem>
        <FormItem label="证据包md5" prop="packageMd5" >
          <Input v-model="infoForm.packageMd5" style="width:100%"/>
        </FormItem>
        <FormItem label="证据包sha256" prop="packageSha256" >
          <Input v-model="infoForm.packageSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="截屏sha256" prop="screenshotSha256" >
          <Input v-model="infoForm.screenshotSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="dns服务器ip" prop="dnsServerIp" >
          <Input v-model="infoForm.dnsServerIp" style="width:100%"/>
        </FormItem>
        <FormItem label="取证服务器外网IP" prop="serverIp" >
          <Input v-model="infoForm.serverIp" style="width:100%"/>
        </FormItem>
        <FormItem label="取证网页原码sha256" prop="sourceFileSha256" >
          <Input v-model="infoForm.sourceFileSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程日志sha256" prop="logFileSha256" >
          <Input v-model="infoForm.logFileSha256" style="width:100%"/>
        </FormItem>
        <FormItem label="取证固定过程日志" prop="logContent" >
          <textarea rows="10" v-model="infoForm.logContent" style="width:100%"/>
        </FormItem>
        <FormItem label="DNS返回网址对应IP" prop="dnsDomainIp" >
          <Input v-model="infoForm.dnsDomainIp" style="width:100%"/>
        </FormItem>
        <FormItem label="网页原码文件" prop="sourceFileName" >
          <Input v-model="infoForm.sourceFileName" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程文件名称" prop="processRecordFileName" >
          <Input v-model="infoForm.processRecordFileName" style="width:100%"/>
        </FormItem>
        <FormItem label="固定过程文件hash" prop="processRecordFileSha256" >
          <Input v-model="infoForm.processRecordFileSha256" style="width:100%"/>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
import EvidenceWebpageTipImg from './EvidenceWebpageTipImg';
export default {
  name: "EvidenceWebpage",
  components: {
    EvidenceWebpageTipImg
  },
  data() {
    return {
      activities: [],
      infoDrawerVisible: false,
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        evidenceOrder: "",
        evidenceOrderExtends: "",
        payWay: "",
        id: "",
        registerId: "",
        url: "",
        domain: "",
        content: "",
        source: "",
        beginTime: "",
        endTime: "",
        screenshotUrl: "",
        packageUrl: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        remarks: "",
        delFlag: "",
        name: "",
        orderSeqNo: "",
        pacageSize: "",
        packageMd5: "",
        packageSha256: "",
        screenshotSha256: "",
        dnsServerIp: "",
        serverIp: "",
        sourceFileSha256: "",
        logFileSha256: "",
        logContent: "",
        dnsDomainIp: "",
        sourceFileName: "",
        processRecordFileName: "",
        processRecordFileSha256: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        // {
        //   title: "支付方式",
        //   key: "payWay",
        //   minWidth: 120,
        //   sortable: false,
        // },
        /*{
          title: "id",
          key: "id",
          minWidth: 50,
          sortable: false,
        },*/
        {
          title: "用户",
          key: "registerId",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.register.name);
          }
        },
        {
          title: "取证网址",
          key: "url",
          minWidth: 240,
          sortable: false,
          /*render(h, params){
            return h('span', {
              style: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              },
              attrs: {
                title: params.row.url
              }
            }, params.row.url);
          }*/
          render(h, params){
            return h(EvidenceWebpageTipImg, {props: {
              screenshotUrl: params.row.screenshotUrl,
              url: params.row.url,
            }});
          }
        },
        {
          title: "取证名称",
          key: "name",
          minWidth: 180,
          sortable: false,
          render(h, params){
            return h('span', {
              style: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              },
              attrs: {
                title: params.row.name
              }
            }, params.row.name);
          }
        },
        {
          title: "取证状态",
          key: "url",
          minWidth: 120,
          sortable: false,
          render(h, params){
            /*let status = '未知';
            switch(params.row.evidenceOrder.status){
              case 'prepare':
                status = '未开始';
                break;
              case 'saving-evidence':
                status = '取证中';
                break;
              case 'evidence-saved':
                status = '完成';
                break;
              case 'failed':
                status = '失败';
              case 'cert-sign-issue':
                status = '证书已生成';
                break;
              default:
                break;
            }*/
            return h('span', params.row.evidenceOrder.status);
          }
        },
        {
          title: "订单编号",
          key: "orderSeqNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "域名",
          key: "domain",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证说明",
          key: "content",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "申请渠道",
          key: "source",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证开始时间",
          key: "beginTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证结束时间",
          key: "endTime",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "网页截图URL",
          key: "screenshotUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证据包URL",
          key: "packageUrl",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "创建者",
          key: "createBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新者",
          key: "updateBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新时间",
          key: "updateDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "删除标记",
          key: "delFlag",
          minWidth: 120,
          sortable: false,
        },*/


        {
          title: "证据包长度",
          key: "pacageSize",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "证据包md5",
          key: "packageMd5",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "package sha256",
          key: "packageSha256",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "截屏sha256",
          key: "screenshotSha256",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "dns服务器ip",
          key: "dnsServerIp",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证服务器外网IP",
          key: "serverIp",
          minWidth: 120,
          sortable: false,
        },
       /* {
          title: "取证网页原码sha256",
          key: "sourceFileSha256",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "固定过程日志sha256",
          key: "logFileSha256",
          minWidth: 120,
          sortable: false,
        },*/
        /*{
          title: "取证固定过程日志",
          key: "logContent",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "DNS返回网址对应IP",
          key: "dnsDomainIp",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "网页原码文件",
          key: "sourceFileName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "固定过程文件名称",
          key: "processRecordFileName",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "固定过程文件hash",
          key: "processRecordFileSha256",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row);
                    }
                  }
                },
                "查看详情"
              ),
              /*h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              )*/
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0, // 表单数据总数
      infoForm: {
        register: {},
        evidenceOrder: {},
        evidenceOrderExtends: {}
      }
    };
  },
  methods: {
    init() {
      this.getRequest("/activity/getAll", {}).then(res => {
        if (res.success) {
          this.activities = res.result;
          this.getDataList();
        }
      });
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      this.searchForm.activityId = '';
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/evidenceWebpage/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // 以下为模拟数据
      //this.data = [
      //];
      // this.total = this.data.length;
      // this.loading = false;
    },
    detail(row) {
      this.infoForm = row;
      this.infoDrawerVisible = true;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    },
    conditionExport() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/evidenceWebpage/export", this.searchForm, 'blob').then(response => {
        this.loading = false;
        var blob = new Blob([response])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '网页取证订单.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象

        console.log(response);
      });
      // 以下为模拟数据
      //this.data = [
      //];
      // this.total = this.data.length;
      // this.loading = false;
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>